import { LinkProps } from '@mui/material/Link'
import { createTheme } from '@mui/material/styles'

import { LinkBehavior } from './LinkBehavior'
import { isIS } from '@mui/material/locale'

/*
Regular: 400
Medium: 500
Semi-bold: 600
Bold: 700
*/

// Create a theme instance.
const themeBase = (dark?: boolean) =>
  createTheme(
    {
      palette: {
        mode: dark ? 'dark' : 'light',
      },
      typography: {
        fontFamily: '"Poppins", sans-serif',

        h1: {
          fontWeight: 400,
          fontSize: '2rem', //32px
          lineHeight: '2.5rem', //40px
        },
        h2: {
          fontWeight: 400,
          fontSize: '1.75rem', //28px
          lineHeight: '2.25rem', //36px
        },
        h3: {
          fontWeight: 400,
          fontSize: '1.5rem', //24px
          lineHeight: '2rem', //32px
        },
        h4: {
          fontWeight: 400,
          fontSize: '1.25rem', //20px
          lineHeight: '1.75rem', //28px
        },
        h5: {
          fontWeight: 400,
          fontSize: '1rem', //16px
          lineHeight: '1.5rem', //24px
        },
        h6: {
          fontWeight: 400,
          fontSize: '0.875rem', //14px
          lineHeight: '1.25rem', //20px
        },
        body1: {
          fontWeight: 400,
          fontSize: '0.875rem', //16px
          lineHeight: '1.5rem', //24px
        },
        subtitle1: {
          fontWeight: 400,
          fontSize: '1rem', //16px
          lineHeight: '1.25rem', //20px
        },
        subtitle2: {
          fontWeight: 400,
          fontSize: '0.875rem', //14px
          lineHeight: '1.25rem', //20px
        },
      },
      mixins: {
        toolbar: {
          minHeight: '3rem', //48px
          maxHeight: '3rem', //48px
        },
      },
      components: {
        MuiTable: {
          styleOverrides: {
            root: {
              display: 'table',
            },
          },
        },
        MuiTableCell: {
          styleOverrides: {
            head: {
              fontSize: '0.75rem', //12px
              lineHeight: '1rem', //16px
              paddingLeft: '8px',
              paddingRight: '8px',
            },
            body: {
              fontSize: '0.75rem', //12px
              lineHeight: '1rem', //16px
              padding: '8px',
            },
          },
        },
        MuiSelect: {
          styleOverrides: {
            select: {
              fontSize: '0.75rem', //12px
              lineHeight: '1rem', //16px
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              fontSize: '0.825rem', //14px
              lineHeight: '1rem', //16px
            },
          },
        },

        MuiButton: {
          styleOverrides: {
            root: {
              boxShadow: 'none',
              fontSize: '0.875rem', //14px
              ':hover': {
                boxShadow: 'none',
              },
            },
          },
        },
        MuiChip: {
          styleOverrides: {
            label: {
              pl: '0.875rem', //14px
              pr: '0.875rem', // 14px
              fontSize: '0.688rem', //11px
            },
          },
        },
        MuiLink: {
          defaultProps: {
            component: LinkBehavior,
            fontFamily: '"Poppins", sans-serif',
            underline: 'none',
          } as LinkProps,
        },
        MuiButtonBase: {
          defaultProps: {
            LinkComponent: LinkBehavior,
          },
        },
        MuiTab: {
          styleOverrides: {
            root: {
              fontSize: '0.75rem', //12px
            },
          },
        },
        MuiTabs: {
          styleOverrides: {
            scrollButtons: {
              '&.Mui-disabled': {
                opacity: '0.3',
              },
            },
          },
        },
        MuiFormControlLabel: {
          styleOverrides: {
            label: {
              fontSize: '0.688rem', //11px
              fontWeight: 500,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontSize: '0.75rem', //12px
              padding: 0,
            },
          },
        },
      },
    },
    isIS,
    {
      components: {
        MuiTablePagination: {
          defaultProps: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            labelDisplayedRows: ({ from, to, count }: any) =>
              `${from}–${to} af ${count !== -1 ? count : `fleirum en ${to}`}`,
          },
        },
      },
    },
  )

export default themeBase
